export const FETCH_SUBSCRIBER_PACKETS = 'packetsSubscription/:id/details';
